export const CURRENCIES_REQUESTED = 'CURRENCIES_REQUESTED'
export const CURRENCIES_RECEIVED = 'CURRENCIES_RECEIVED'
